module.exports = __webpack_public_path__ + "img/bt_instagram_hover.f7cfa4dc.svg";